import { get, post } from '@/common/request/index';

export interface CurrentUserInfo {
  /**
   * 头像地址
   */
  avatar?: null;
  /**
   * 所属部门
   */
  departmentIds?: string[];
  id?: number;
  /**
   * 手机号
   */
  mobile?: string;
  /**
   * 菜单权限列表
   */
  moduleList?: UserInfoModuleList[];
  /**
   * 姓名
   */
  name?: string;
  /**
   * 所属岗位
   */
  positionIds?: string[];
  /**
   * 所属角色
   */
  roleIds?: number[];
  /**
   * 企业名
   */
  tenant?: string;
  email?: string;
  /**
   * 当前租户的运维人员手机号
   */
  technicalMobile?: string;
  /**
   * 所属角色编码
   */
  roleEncodes?: string[];

  /**
   * 用户有权限的城市
   */
  cities?: UserCity[];
}

export interface UserInfoModuleList {
  children?: UserInfoChild[];
  encode?: string;
  icon?: string;
  id?: number;
  name?: string;
  parent?: null;
  sortNum?: string;
  uri: string;
}

export interface UserCity {
  id?: number;
  provinceId?:number;
}

export interface UserInfoChild {
  children: string[];
  encode: string;
  icon: null;
  id: number;
  name: string;
  parent: UserInfoParent;
  sortNum: string;
  uri: string;
}

export interface UserInfoParent {
  children?: null;
  encode?: string;
  icon?: string;
  id?: number;
  name?: string;
  parent?: null;
  sortNum?: string;
  uri?: string;
}

/**
 * 当前登录用户信息 https://yapi.lanhanba.com/project/297/interface/api/33423
 */
export function currentUserInfo() {
  return get('/user/currentUser', {}, { needCancel: false });
}

/**
 * 用户列表
 * https://yapi.lanhanba.com/project/297/interface/api/33443
 */
export function userList(params?: any) {
  return post('/user/list', { ...params }, { mockId: 297, isMock: false });
}

/**
 * 用户列表-分公司权限
 * https://yapi.lanhanba.com/project/297/interface/api/93052
 */
export function userAuthorityList(params?: any) {
  return post('/user/authority/list', { ...params }, { mockId: 297, isMock: false });
}

/**
 * 用户列表(根据账号权限)（含离职员工，所以不适合作为指派用）
 * https://yapi.lanhanba.com/project/297/interface/api/88498
 */
export function userPermissionList(params?: any) {
  return get('/user/permission/list', { ...params }, { needCancel: false });
}

/**
 * 用户搜索
 * https://yapi.lanhanba.com/project/297/interface/api/33385
 */
export function userSearch(params?: any) {
  return get('/user/search', { ...params }, { needCancel: false });
}

/**
 * 员工分页列表
 * https://yapi.lanhanba.com/project/297/interface/api/92692
 * @description 目前专门给加盟商-新增/编辑/转交归属人用
 */
export function getUserPageList(params?: any) {
  return post('/user/pageList', { ...params }, { needCancel: false });
}
